import { useSetAtom } from 'jotai';
import { domain } from 'modules/data';
import { useEffect, useMemo } from 'react';
import { breadcrumbsHeaderState, useReportsLinkItems } from 'shared/components';
import { useCompanyBasedOnUrl } from 'shared/hooks/useCompanyBasedOnUrl';

export const useBreadcrumbs = (reportsType: domain.ReportType) => {
    const company = useCompanyBasedOnUrl();
    const setBreadcrumbs = useSetAtom(breadcrumbsHeaderState);
    const reportsLinkItems = useReportsLinkItems(company)[0];

    const breadcrumbs = useMemo(() => {
        const currentItem = reportsLinkItems.subItems.find(({ id }) => id === reportsType);

        return [
            {
                name: reportsLinkItems.name,
                to: currentItem?.to,
            },
            {
                value: currentItem?.to,
                subItems: reportsLinkItems.subItems.filter(({ available }) => available ?? true),
            },
        ];
    }, [reportsType, reportsLinkItems.name, reportsLinkItems.subItems]);

    useEffect(() => {
        setBreadcrumbs(breadcrumbs);
    }, [breadcrumbs, setBreadcrumbs]);
};
